import { Link } from "react-router-dom";
import {
    FaArrowRight,
    FaHotel,
    FaStar,
    FaCheckCircle
} from "react-icons/fa";

export default function CTASection() {
    return (
        <section className="relative py-16 sm:py-20 lg:py-24 overflow-hidden bg-slate-50">

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

                {/* Main CTA */}
                <div className="relative overflow-hidden rounded-[32px] sm:rounded-[40px] bg-[#002B45] shadow-[0_25px_70px_rgba(0,43,69,0.22)]">

                    {/* Background Glow */}
                    <div className="absolute -top-40 -right-32 w-[450px] h-[450px] rounded-full bg-[#D4A83F]/15 blur-3xl"></div>

                    <div className="absolute -bottom-40 -left-32 w-[450px] h-[450px] rounded-full bg-[#174B5F]/30 blur-3xl"></div>

                    {/* Decorative Circle */}
                    <div className="absolute top-10 right-[10%] w-32 h-32 rounded-full border border-white/10"></div>

                    <div className="absolute top-16 right-[12%] w-20 h-20 rounded-full border border-[#D4A83F]/20"></div>

                    {/* Top Accent */}
                    <div className="absolute top-0 left-0 right-0 h-1.5 bg-gradient-to-r from-[#002B45] via-[#174B5F] to-[#D4A83F]"></div>

                    <div className="relative z-10 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center px-7 py-12 sm:px-10 sm:py-14 md:px-16 md:py-16">

                        {/* Left Content */}
                        <div className="lg:col-span-8 text-center lg:text-left">

                            {/* Badge */}
                            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 border border-white/10 backdrop-blur-md mb-6">

                                <FaHotel className="text-[#D4A83F] text-xs" />

                                <span className="text-xs sm:text-sm font-semibold text-white/90">
                                    DUBAI HOTEL DEALS
                                </span>

                            </div>

                            {/* Heading */}
                            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold !text-white leading-[1.08] max-w-3xl">

                                Your Dubai Stay
                                <span className="block text-[#D4A83F]">
                                    Starts Here.
                                </span>

                            </h2>

                            {/* Description */}
                            <p className="mt-5 text-slate-300 text-sm sm:text-base lg:text-lg leading-7 max-w-2xl mx-auto lg:mx-0">
                                Discover handpicked hotels, exclusive deals and
                                unforgettable stays across Dubai — all in one place.
                            </p>

                            {/* Trust Points */}
                            <div className="flex flex-wrap justify-center lg:justify-start gap-x-6 gap-y-3 mt-7">

                                <div className="flex items-center gap-2 text-sm text-white/80">
                                    <FaCheckCircle className="text-[#D4A83F]" />
                                    Best Hotel Deals
                                </div>

                                <div className="flex items-center gap-2 text-sm text-white/80">
                                    <FaCheckCircle className="text-[#D4A83F]" />
                                    Trusted Hotels
                                </div>

                                <div className="flex items-center gap-2 text-sm text-white/80">
                                    <FaCheckCircle className="text-[#D4A83F]" />
                                    Easy Booking
                                </div>

                            </div>

                            {/* Buttons */}
                            <div className="flex flex-col sm:flex-row justify-center lg:justify-start gap-3 sm:gap-4 mt-9">

                                <Link
                                    to="/hotels"
                                    className="group inline-flex items-center justify-center gap-3 px-7 py-3.5 sm:px-8 sm:py-4 bg-[#D4A83F] hover:bg-[#E6C66A] text-[#002B45] rounded-xl font-bold shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300"
                                >
                                    Explore Hotels

                                    <span className="flex items-center justify-center w-7 h-7 rounded-full bg-[#002B45] text-white group-hover:translate-x-1 transition-transform">
                                        <FaArrowRight className="text-[10px]" />
                                    </span>
                                </Link>

                                <Link
                                    to="/contact-us"
                                    className="inline-flex items-center justify-center px-7 py-3.5 sm:px-8 sm:py-4 bg-white/5 border border-white/20 text-white rounded-xl font-semibold backdrop-blur-sm hover:bg-white hover:text-[#002B45] transition-all duration-300"
                                >
                                    Talk to Our Team
                                </Link>

                            </div>

                        </div>

                        {/* Right Trust Card */}
                        <div className="lg:col-span-4">

                            <div className="relative max-w-sm mx-auto lg:ml-auto">

                                {/* Glow */}
                                <div className="absolute inset-0 bg-[#D4A83F]/20 blur-2xl rounded-full"></div>

                                {/* Card */}
                                <div className="relative bg-white/[0.08] backdrop-blur-xl border border-white/10 rounded-3xl p-6 sm:p-7">

                                    {/* Icon */}
                                    <div className="w-14 h-14 rounded-2xl bg-[#D4A83F] text-[#002B45] flex items-center justify-center shadow-lg">
                                        <FaHotel className="text-xl" />
                                    </div>

                                    <h3 className="text-white text-xl font-bold mt-5">
                                        Find Your Perfect Hotel
                                    </h3>

                                    <p className="text-slate-300 text-sm leading-6 mt-2">
                                        From beachfront resorts to luxury city
                                        stays, find the right hotel for your trip.
                                    </p>

                                    {/* Rating */}
                                    <div className="flex items-center gap-3 mt-6 pt-5 border-t border-white/10">

                                        <div className="flex items-center gap-1">
                                            {[...Array(5)].map((_, i) => (
                                                <FaStar
                                                    key={i}
                                                    className="text-[#D4A83F] text-xs"
                                                />
                                            ))}
                                        </div>

                                        <span className="text-sm font-bold text-white">
                                            4.9/5
                                        </span>

                                    </div>

                                    <p className="text-xs text-slate-400 mt-2">
                                        Trusted by travelers booking stays in Dubai
                                    </p>

                                </div>

                            </div>

                        </div>

                    </div>
                </div>

            </div>

        </section>
    );
}